import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["rows", "template", "addButton"];
  static values = { groupMatchers: String, defaultNames: String };

  connect() {
    this.syncMatchValueInputs();
    this.syncOverrideHints();
    this.toggleRowsVisibility();
  }

  addMapping(event) {
    event.preventDefault();
    const index = this.nextIndex();
    const html = this.templateTarget.innerHTML.replace(/__INDEX__/g, index);
    this.rowsTarget.insertAdjacentHTML("beforeend", html);
    this.showRows();
    this.toggleMatchValueForRow(this.lastRow());
  }

  removeMapping(event) {
    event.preventDefault();
    const row = event.target.closest("[data-saml-attribute-mapping-row]");
    if (row) {
      row.remove();
    }
    this.toggleRowsVisibility();
  }

  toggleMatchValue(event) {
    const row = event.target.closest("[data-saml-attribute-mapping-row]");
    if (!row) {
      return;
    }

    this.toggleMatchValueForRow(row);
  }

  syncMatchValueInputs() {
    this.rowElements().forEach((row) => this.toggleMatchValueForRow(row));
  }

  toggleOverrideHint(event) {
    const row = event.target.closest("[data-saml-attribute-mapping-row]");
    if (!row) {
      return;
    }

    this.toggleOverrideHintForRow(row);
  }

  syncOverrideHints() {
    this.rowElements().forEach((row) => this.toggleOverrideHintForRow(row));
  }

  toggleOverrideHintForRow(row) {
    const nameInput = row.querySelector("[data-saml-attribute-mapping-name]");
    const hint = row.querySelector("[data-saml-attribute-mapping-override-hint]");
    if (!nameInput || !hint) {
      return;
    }

    const name = nameInput.value.trim();
    const isDefaultName = this.defaultNameValues().includes(name);
    if (isDefaultName) {
      const nameElement = hint.querySelector("[data-saml-attribute-mapping-override-name]");
      if (nameElement) {
        nameElement.textContent = name;
      }
    }
    hint.style.display = isDefaultName ? "" : "none";
  }

  defaultNameValues() {
    if (!this.hasDefaultNamesValue || !this.defaultNamesValue) {
      return [];
    }

    return this.defaultNamesValue.split(",").map((value) => value.trim()).filter(Boolean);
  }

  toggleMatchValueForRow(row) {
    const valueSelect = row.querySelector("[data-saml-attribute-mapping-value]");
    const matchWrapper = row.querySelector("[data-saml-attribute-mapping-match-wrapper]");
    const matchInput = row.querySelector("[data-saml-attribute-mapping-match]");
    if (!valueSelect || !matchInput) {
      return;
    }

    const shouldEnable = this.groupMatcherValues().includes(valueSelect.value);
    matchInput.disabled = !shouldEnable;
    matchInput.value = shouldEnable ? matchInput.value : "";
    if (matchWrapper) {
      matchWrapper.style.display = shouldEnable ? "" : "none";
    }
  }

  rowElements() {
    return this.rowsTarget.querySelectorAll("[data-saml-attribute-mapping-row]");
  }

  lastRow() {
    const rows = this.rowElements();
    return rows[rows.length - 1];
  }

  nextIndex() {
    return this.rowElements().length;
  }

  groupMatcherValues() {
    if (!this.hasGroupMatchersValue || !this.groupMatchersValue) {
      return [];
    }

    return this.groupMatchersValue.split(",").map((value) => value.trim()).filter(Boolean);
  }

  toggleRowsVisibility() {
    if (this.rowElements().length === 0) {
      this.rowsTarget.style.display = "none";
    } else {
      this.showRows();
    }
  }

  showRows() {
    this.rowsTarget.style.display = "";
  }
}
